import axios from 'axios';
import React, {Component} from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import boundary_unselect from './Images/boundary_unselect.png';
import map_view from './Images/map_view.png'
import settings_map from './Images/settings.png';
import Tasks from './Images/TasksImage.png';
import tour_map from './Images/tour.png';
import building_model from './Images/3d_model.png';
import CompetitorImage from './Images/CompetitorImage.png'
import TutorialImage from './Images/TutorialImage.png'
import pin_img from './Images/pin.png';
import {ReactComponent as Places} from './Layer_images/Places.svg'
import {ReactComponent as Buildings} from './Layer_images/Buildings.svg'
import {ReactComponent as Cluster} from './Layer_images/Cluster.svg'
import {ReactComponent as Competitor} from './Layer_images/Competitor.svg'
import {ReactComponent as Datalayer} from './Layer_images/Datalayer.svg'
import {ReactComponent as Shop} from './Layer_images/Shop.svg'
import {ReactComponent as Zipcode} from './Layer_images/Zipcode.svg'
import {ReactComponent as Traffic} from './Layer_images/Traffic.svg'
import {ReactComponent as Mapchise_logo} from './Layer_images/Mapchise-logo.svg'
import {ReactComponent as Search_bar} from './Layer_images/Search-bar.svg'
import {ReactComponent as More_Vertical} from './Layer_images/More-vertical.svg'
import {ReactComponent as StreetView} from './Layer_images/StreetView.svg'
import {ReactComponent as Drop_Pin} from './Layer_images/Settings_images/droppin.svg'
import {ReactComponent as Map_Type} from './Layer_images/Settings_images/map.svg'
import {ReactComponent as ThreeDView} from './Layer_images/Settings_images/3dView.svg'
import {ReactComponent as TourImage} from './Layer_images/Settings_images/routing-2.svg'
import {ReactComponent as Tutorial} from './Layer_images/Settings_images/tutorial.svg'
import {ReactComponent as CompetitorSearchImage} from './Layer_images/Settings_images/competitor-search.svg'
import {ReactComponent as SettingImage} from './Layer_images/Settings_images/setting-2.svg'


import Tooltip from '@mui/material/Tooltip';
import MainSearchBar from './ui_components/MainsearchBar';

const WAIT_INTERVAL = 800;

export class Statusside extends Component{
    constructor(props) {
      super(props);
    this.state = {
        search: [],
        searchbar: false,
        searchterm_comp: "",
        squareclicked: false,
        showresult: false,
        industryclicked: false,
        filter: null,
        fss: true,
        fssInfoShow: false,
        placesInfoShow: false,
        clusterInfoShow: false,
        buildingsInfoShow: false,
        trafficInfoShow: false,
        shoppingInfoShow: false,
        cluster: true,
        question: 'none',
        percent_diff: null,
        color_percentdiff: null,
        arrangement: [],
        hidesidebar: false,
        prospect: false,
        prospect_place: false,
        search_comp_values: [],
        prossearch: '',
        back_color: 'white',
        showlayer: 'none',
        showview: 'none',
        searchterm: '',
        mapview: "Default",
        prostype: 'Prospecting Location',
        showResults: true,
        type: []
    }
    this.search_loc = this.search_loc.bind(this);
    this.prospecttotalhide = this.prospecttotalhide.bind(this);
    this.prospectsetup = this.prospectsetup.bind(this);
    this.prospectsetupcurrent = this.prospectsetupcurrent.bind(this);
    // this.handleKeyDown = this.handleKeyDown.bind(this)
    // this.searchclick = this.searchclick.bind(this);
    }
    componentWillMount(){
        this.timer= null;
    }
    triggersend = async (searchTerm, type) =>  {
        if(searchTerm === '') return this.setState({search: []});  ;
        let token = localStorage.getItem("auth-token");
        var search_res = await axios.post('/gettheurl/location', {searcher:true, search:searchTerm ,center: this.props.center, bounds:''}, {headers:{ "auth-token": token}});
        let search = await search_res.data;
        search = search.filter((e) => e.position || e.subcategory).slice(0, 6)
        this.setState({search});    

        
        // if(this.state.prostype === "Prospecting Location"){
        // if(type){
            // console.log('search: ', search)


        // }
        // else{
        //     search = search.filter((e) => !e.position && !e.subcategory)
        //     search = search.map((e) => e.title)
        //     function onlyUnique(value, index, self) { return self.indexOf(value) === index;}
        //     search = search.filter(onlyUnique);

        //     this.setState({search_comp_values: search})
        // }
            
    }
    async search_loc(e) {
        if(e == '') return this.setState({search: [], searchterm: ''})
        this.setState({searchterm: e, showResults:true})
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.triggersend(e, true), WAIT_INTERVAL);
    }
    // async search_boundaries(){
    //     // if(this.state.prostype === "Search Boundaries"){
    //         let token = localStorage.getItem("auth-token");
    //         var search_res = await axios.post('/gettheurl/locationquery', {search: this.state.searchterm ,center: this.props.center, bounds:''}, {headers:{ "auth-token": token}});
    //         let search = await search_res.data;
    //         if(search.length> 0 ){
    //             search.map((ee) => this.props.createmarkerhere(ee, "blue"))
                
    //             this.hideresults()
    //         }
    //     // }
    // }
    // handleKeyDown(e) { if (e.key === 'Enter') { this.search_boundaries();}}
    // searchclick(){
    //     this.search_boundaries()
    // }
    prospectsetup(){
        this.setState({prospect: false,  }, () =>{
            this.props.dropthepin(['Prospect Business', 'prospect'], 'droper')
        })
    }
    showresults = () => {
        this.prospecttotalhide()
        this.setState({showresult: true})
      }
    hideresults(){
        this.setState({searchBar: false, search: [], searchTerm: ''})
    }
    squareclick_show(){
          this.setState({squareclicked: !this.state.squareclicked})
        
    }
    sendingnew = (pos, title, subcategory, Image, single, value=null) => {
        // console.log('pos: ', pos, title, subcategory)
        /** This sends the data to the parent */
        if(single){
            this.props.searchBarSingleBrand([value])
        }
        else if(subcategory){
            this.props.searchBarGetBrand({title, subcategory, Image, status: true})
        }else{
            this.props.droppingcheck({type:"Point", coordinates: [pos[1], pos[0]]}, title)
        }
        this.hideresults();
    }
    sendingnew_comp = (title) =>{
        this.setState({searchterm: title, search_comp_values:[]}, () =>{ this.search_boundaries() })

    }
    prospecttotal(){
        
        this.setState({prospect: true});
    }
    prospecttotalhide(){
        this.setState({prospect: false})
    }

    prospectsetupcurrent(){
        this.setState({prospect: false,  }, () =>{
            this.props.dropthepin(['Current Business', 'business'], 'droper')
        })
    }

    // _handleKeyDown(e) { if (e.key === 'Enter') this.prospectsenddata() }
    prospectsearch(e){
          this.setState({prossearch: e.target.value})
    }
    async prospectsenddata(){
       let search =  await axios.post('/gettheurl/prospectsearch', { search: this.state.prossearch });
       search = await search.data;
       console.log(search, 'search value')
       if(search.address)
        {   let coordinates = {};
            coordinates.latlng = {lat: search.coordinates.Latitude, lng: search.coordinates.Longitude};
            this.setState({searchbar: false});
            this.props.dropthepin(this.state.type,'search', coordinates,search.address)
        }else{
            this.setState({back_color: 'rgb(250,128,114)'})
        }
    }
    showmaplayers(){
        this.setState({showlayer: 'block'})
    }
    hidemaplayers(){
        this.setState({showlayer: 'none'})
    }
    showview = () => {
        this.setState({showview: 'block'})
    }
    hideview = () => {
        this.setState({showview: 'none'})
    }
    // prospectingtype(){
    //     console.log(this.state.prostype)
    //     if(this.state.prostype == "Prospecting Location"){
    //         this.setState({prostype:"Search Boundaries", search:[]})
    //     }
    //     else{
    //     this.setState({prostype:"Prospecting Location"})
    //     }
    // }
    changemapview(map, val){
        this.setState({mapview: val})
        this.props.maptilelayer(map)
        
    }

    
    showzoomed = (img, turf_area=210000000) => {
        if(this.props.turf_area >= turf_area) 
        {
          if(img) return "Building-imagemain-layer-blue";
          
          return "Building-each2 Building-each-selected-blue"
        }
        if(img) return "Building-imagemain-layer"
        return "Building-each2 Building-each-selected"
    }

    showWarningFunc = (indictor, turf_area=210000000) => {
        if(this.props.turf_area >= turf_area && indictor){
            return 'sidebar-show-warning'
        }
        return 'display-none'
    }

    showPlaces = (img, indicator) => {
        if(!this.props.placeSearch) 
        {
          if(img) return "Building-imagemain-layer-blue";
          
          return "Building-each2 Building-each-selected-blue"
        }
        if(img) return "Building-imagemain-layer"
        return "Building-each2 Building-each-selected"
    }

    showInfo = (hovering, type, turf_area = 210000000) => {
        const typeConfig = {
            // fss: { condition: !this.props.placeSearch, stateKey: 'fssInfoShow' },
            cluster: { condition: this.props.cluster && this.props.turf_area >= turf_area, stateKey: 'clusterInfoShow' },
            places: { condition: !this.props.placeSearch, stateKey: 'placesInfoShow' },
            buildings: { condition: this.props.building && this.props.turf_area >= turf_area, stateKey: 'buildingsInfoShow' },
            traffic: { condition: this.props.traffic && this.props.turf_area >= turf_area, stateKey: 'trafficInfoShow' },
            shopping: { condition: this.props.shoppingcenter && this.props.turf_area >= turf_area, stateKey: 'shoppingInfoShow' },
        };
    
        const config = typeConfig[type];
        if (config) {
            this.setState({ [config.stateKey]: hovering && config.condition });
        }
    };    

    getPopUp = (type, title="Zoom in to refresh" ) => {
        const openList = {
            fss: this.state.fssInfoShow,
            places: this.state.placesInfoShow,
            cluster: this.state.clusterInfoShow,
            buildings: this.state.buildingsInfoShow,
            traffic: this.state.trafficInfoShow,
            shopping: this.state.shoppingInfoShow
        }
        return <Tooltip 
            title={title}
            open={openList[type]}  
            disableFocusListener
            disableTouchListener
            placement="right"
            PopperProps={{
            modifiers: [
                {
                name: 'offset',
                options: {
                    offset: [-30, 55],  
                },
                },
            ],
            }}
        >
            <span>{}</span>
        </Tooltip>
    }

    render() {
      
        return (
            <div id="Status-total">
                <div style={{zIndex:3, position:'relative'}} >
                    <div id="Layer-filter-total" data-tut='reactour__maplayer'>
                        <div className='w-67 flex-direction-column'>
                            <Mapchise_logo width={58} style={{marginLeft: '6px'}}/>
                        <div className="Layer-filter-name">LAYERS</div>
                        <div className={`Layer-filter-each ${this.props.building ? "Layer-filter-each-selected": ''}`} onClick={()=> this.props.turnthison('building')} onMouseOver={() => this.showInfo(true, 'buildings', 20000000000)} onMouseOut={() => this.showInfo(false, 'buildings', 20000000000)}>
                        {/* {(this.props.freetier)? <div className="fa fa-lock Layer-filter-lock-freetier" ></div>: */}
                        <div><div className={`Layer-border-right ${this.props.building_show ? "Layer-border-right-blue": ''}`}></div>
                        <div className={`${this.showWarningFunc(this.props.building, 20000000000)}`}>!</div>
                        <Buildings  className={(this.props.building)?"Building-imagemain-layer":"Competitor-sidebar-image-layer"}/></div>
                        {/* } */}
                            <div className={(this.props.building)?"Building-each2 Building-each-selected": "Building-each2"}>Buildings</div>
                            {this.getPopUp('buildings')}
                        </div>
                        <div className={`Layer-filter-each ${this.props.cluster ? "Layer-filter-each-selected": ''}`} onClick={()=> {this.props.freetier ? this.props.premiumFeatureClicked('cluster') : this.props.turnthison('cluster')}} onMouseOver={() => this.showInfo(true, 'cluster')} onMouseOut={() => this.showInfo(false, 'cluster')}>
                        {(this.props.freetier)? <div className="fa fa-lock Layer-filter-lock-freetier" ></div>:<div>
                        <div className={`${this.showWarningFunc(this.props.cluster)}`}>!</div>
                        <Cluster  className={(this.props.cluster)?"Building-imagemain-layer":"Competitor-sidebar-image-layer"}/>
                        </div>}
                            <div className={(this.props.cluster)?"Building-each2 Building-each-selected": "Building-each2"}>Cluster</div>
                            {this.getPopUp('cluster')}
                        </div>
                        <div className={`Layer-filter-each ${this.props.datalayer ? "Layer-filter-each-selected": ''}`} onClick={()=> {this.props.freetier ? this.props.premiumFeatureClicked('data_layer') : this.props.turnthison('datalayer')}}>
                        {(this.props.freetier)? <div className="fa fa-lock Layer-filter-lock-freetier" ></div>:<div>
                        <div className={(this.props.datalayer_show)? "Layer-border-right Layer-border-right-blue": "Layer-border-right"}></div>
                        <div className={`${this.showWarningFunc(this.props.datalayer, 20000000000)}`}>!</div>
                        <Datalayer  className={(this.props.datalayer)?"Building-imagemain-layer":"Competitor-sidebar-image-layer"}/>
                            </div>
                        }
                        <div className={(this.props.datalayer)?"Building-each2 Building-each-selected": "Building-each2"}>Data Layer</div>
                        </div>
                        <div className={`Layer-filter-each ${this.props.places ? "Layer-filter-each-selected": ''}`} onClick={()=> {this.props.freetier ? this.props.premiumFeatureClicked('places') :this.props.turnthison('places')}} onMouseOver={() => this.showInfo(true, 'places', 20000000000)} onMouseOut={() => this.showInfo(false, 'places')}>
                        {(this.props.freetier)? <div className="fa fa-lock Layer-filter-lock-freetier" ></div>:<div>
                        <div className={(this.props.places_show)? "Layer-border-right Layer-border-right-blue": "Layer-border-right"}></div>
                        <div className={`${this.showWarningFunc(this.props.places, 20000000000)}`}>!</div>
                        <Places  className={(this.props.places)? "Building-imagemain-layer":"Competitor-sidebar-image-layer"}/></div>}
                            <div className={(this.props.places)? "Building-each2 Building-each-selected": "Building-each2"}>Places</div>
                            {this.getPopUp('places')}
                        </div>
                        <div className={`Layer-filter-each ${this.props.shoppingcenter ? "Layer-filter-each-selected": ''}`} onClick={()=> this.props.turnthison('shoppingcenter')} onMouseOver={() => this.showInfo(true, 'shopping', 20000000000)} onMouseOut={() => this.showInfo(false, 'shopping')}> 
                        {/* {(this.props.freetier)? <div className="fa fa-lock Layer-filter-lock-freetier" ></div>: */}
                        <div>
                        <div className={`${this.showWarningFunc(this.props.shoppingcenter, 20000000000)}`}>!</div>
                        <Shop  className={(this.props.shoppingcenter)?"Building-imagemain-layer":"Competitor-sidebar-image-layer"}/></div>
                        {/* } */}
                        <div className={(this.props.shoppingcenter)?"Building-each2 Building-each-selected": "Building-each2"}>Shopping Centers</div>
                        {this.getPopUp('shopping')}
                        </div>
                        
                        <div className={`Layer-filter-each ${this.props.traffic ? "Layer-filter-each-selected": ''}`} onClick={()=> this.props.freetier ? this.props.premiumFeatureClicked('traffic') : this.props.turnthison('traffic')} id="layer-traffic-total" onMouseOver={() => this.showInfo(true, 'traffic', 20000000000)} onMouseOut={() => this.showInfo(false, 'traffic', 20000000000)}> 
                        {(this.props.freetier)? <div className="fa fa-lock Layer-filter-lock-freetier" ></div>:<div>
                        <div className={`${this.showWarningFunc(this.props.traffic, 20000000000)}`}>!</div>
                        <Traffic  className={(this.props.traffic)?"Building-imagemain-layer":"Competitor-sidebar-image-layer"}/></div>}
                        <div className={(this.props.traffic)?"Building-each2 Building-each-selected": "Building-each2"}>Traffic Layer</div>
                        {this.getPopUp('traffic')}
                        </div>
                        <div className={`Layer-filter-each ${this.props.otherLayersList.length ? "Layer-filter-each-selected": ''}`} onClick={()=>  this.props.freetier ? this.props.premiumFeatureClicked('other_layer') :  this.props.turnthison('other_layer_tabulation')}> 
                            <div className={(this.props.otherLayerShow)? "Layer-border-right Layer-border-right-blue": "Layer-border-right"}></div>
                            {(this.props.freetier)? <div className="fa fa-lock Layer-filter-lock-freetier" ></div>:<div>
                            <Zipcode  className={(this.props.otherLayersList.length)?"Building-imagemain-layer":"Competitor-sidebar-image-layer"}/></div>}
                            <div className={(this.props.otherLayersList.length)?"Building-each2 Building-each-selected": "Building-each2"}>Other Layers</div>
                        </div>
                        <div className='border-top-1px stick-bottom' >
                            <div className={`Layer-filter-each pb-12 ${this.state.searchBar ? "Layer-filter-each-selected": ''}`} data-tut="reactour__search" onClick={()=> this.setState({searchBar: !this.state.searchBar, search: [], searchTerm: '', showResults: !this.state.showResults})} ><Search_bar className={(this.state.searchBar)?"Building-imagemain-layer mt-5":"Competitor-sidebar-image-layer mt-5"} width={24}/></div>
                            <div className={`Layer-filter-each pb-12 ${this.props.squareclicked ? "Layer-filter-each-selected": ''}`} data-tut="reactour__scroll" onClick={()=> this.setState({squareclicked: !this.state.squareclicked})}><More_Vertical className={(this.state.searchBar)?"Building-imagemain-layer mt-5":"Competitor-sidebar-image-layer mt-5"} width={18}/></div>
                        </div>
                        </div>
                    </div>
                    
                </div>
                <div>
                    <OutsideClickHandler onOutsideClick={()=> this.setState({squareclicked: false})}>

                        <div id="react-status-value" >

                            <div id="container-layers-settings" className={(this.state.squareclicked || this.props.showTour)?"transform-show":" Building-total-hideval"}>
                            <div data-tut="reactour__droppin" className={(this.props.prospect_prospect)?"container-layers-eachval2":"container-layers-eachval2 marker-pin-inside-grey"} onClick={(this.props.prospect_prospect)?this.prospectsetup:() =>{alert("You are out of locations to add. Upgrade your account in the settings")}}><Drop_Pin/><div className="container-layer-text">Drop Pin</div></div>

                            <div className="container-layers-eachval2"   onMouseEnter={this.showview} onMouseLeave={this.hideview}> <Map_Type/> <div className="container-layer-text">Map View</div>
                                <div id= "container-layers-settings-side" style={{display:this.state.showview, top:"25px"}} >
                                    
                                    <div className={(this.state.mapview === "Default")?"container-clicked container-layers-name": "container-layers-name"} onClick={() => this.changemapview("streets-v11", "Default")}>Default</div>
                                    <div className={(this.state.mapview === "Satelite")?"container-clicked container-layers-name": "container-layers-name"} onClick={() => this.changemapview("satellite-streets-v11", "Satelite")}>Satelite</div>
                                    <div className={(this.state.mapview === "Light")?"container-clicked container-layers-name": "container-layers-name"} onClick={() => this.changemapview("light-v9", "Light")}>Light</div>
                                    <div className={(this.state.mapview === "Dark")?"container-clicked container-layers-name": "container-layers-name"} onClick={() => this.changemapview("dark-v9", "Dark")}>Dark</div>
                                    <div className={(this.state.mapview === "Topographic")?"container-clicked container-layers-name": "container-layers-name"} onClick={() => this.changemapview("outdoors-v9", "Topographic")}>Topographic</div>
                                </div>
                                
                            </div>
                            <div className={`container-layers-eachval2 ${this.props.building_model && "container-clicked"}`} onClick={() => this.props.turnthison('building_model')} > <ThreeDView/><div className= "container-layer-text">3D Model</div></div>
                            <div className="container-layers-eachval2" onClick={() => this.props.showTourAgain()} ><TourImage/><div className="container-layer-text">Show Tour</div></div>
                            <div className="container-layers-eachval2" onClick={() => window.location.href = "https://mapchise.com/tutorial-page/"} > <Tutorial/><div className="container-layer-text">Tutorial Page</div></div>
                            {/* <div className="container-layers-eachval2" onClick={() => window.location.href = "/competitor"} ><CompetitorSearchImage/><div className="container-layer-text">Competitor Search</div></div> */}
                            <div className="container-layers-eachval2" onClick={() => window.location.href = "/account"} ><SettingImage/><div className="container-layer-text">Settings</div></div>
                            </div>
                        </div> 
                    </OutsideClickHandler>
                </div>
                <div><MainSearchBar  customBrandSearch={this.props.customBrandSearch} searchBarGetBrand={this.props.searchBarGetBrand} sendingnew={this.sendingnew} showTour={this.props.showTour} search={this.state.search} search_loc={this.search_loc} searchterm={this.state.searchterm} searchBar={this.state.searchBar} showResults={this.state.showResults}/>
                </div>
            </div>
        )}
}